<div class="login-container">
  <div class="login-card glass-panel reveal-on-scroll">
    <div class="login-header">
      <img src="logo.svg" alt="Radical Events" class="auth-logo">
      <h2 class="text-gradient">Bem-vindo</h2>
      <p>Acesse sua conta para gerenciar eventos</p>
    </div>

    <mat-card-content>
      <!-- Google Login Button -->
      <div class="google-btn-container">
        <asl-google-signin-button type="standard" size="large" theme="outline" shape="rectangular"
          [width]="360"></asl-google-signin-button>
      </div>

      <div class="divider">
        <span>ou entre com e-mail</span>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="email" placeholder="seu@email.com">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="loginForm.get('email')?.invalid">E-mail inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Senha</mat-label>
          <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password">
          <button mat-icon-button matSuffix (click)="togglePassword()" type="button" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="showPassword">
            <mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.get('password')?.invalid">Senha obrigatória (mín. 6 caracteres)</mat-error>
        </mat-form-field>

        <div class="form-actions">
          <a routerLink="/auth/forgot-password" class="forgot-link">Esqueceu a senha?</a>
          <button mat-raised-button color="accent" class="submit-button" type="submit" [disabled]="loginForm.invalid">
            ENTRAR
          </button>
        </div>
      </form>



      <div class="login-footer">
        <p>Ainda não faz parte da comunidade?</p>
        <button mat-button color="secondary" routerLink="/auth/register" class="register-btn">
          CRIAR UMA CONTA AGORA
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </div>
</div>